import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=718ae40a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=718ae40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ae40a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718ae40a')) {
      api.createRecord('718ae40a', component.options)
    } else {
      api.reload('718ae40a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=718ae40a&scoped=true&", function () {
      api.rerender('718ae40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jfjZTL3VBS3q/JS/teamMember.vue"
export default component.exports